module.exports = __webpack_public_path__ + "img/pinterest.919d8fe4.svg";